import moment from 'moment'

export default function viewClient (clientData) {
  this.$store.state.userData = clientData

  // Create total from transactions
  this.$store.state.userData.total = clientData.transactions
  .reduce((sum, transaction) => {
    return Math.round((sum + parseFloat(transaction.TransAmount)) * 100) / 100
  }, 0)

  // *Tribe-specific - Filter out Muckelshoot transactions before October 2, 2015
  /* 0000354: Client Portal - Remove filtering of Muckleshoot transactions
  if (this.$store.state.userData.clientData.GroupId === 18) {
    clientData.transactions = clientData.transactions.filter((transaction) => !moment(transaction.TransDate, 'YYYY-MM-DD').isBefore('2015-10-02'))
  }
  */
  // Extract Market transactions (increases from investment)
  this.$store.state.userData.market = clientData.transactions
  .filter((transaction) => transaction.TransType === 'MK')

  // Create cumulative sum over time of all transactions
  let transactions = this.$store.state.userData.transactions
  .map(function (transaction) {
    return {x: moment(transaction.TransDate, 'YYYY-MM-DD'), y: parseFloat(transaction.TransAmount)}
  })
  .sort(function (left, right) {
    return left.x.diff(right.x)
  })

  let transactionsSum = transactions.length > 0 ? [{x: transactions[0].x, y: transactions[0].y}] : []
  for (let i = 1; i < transactions.length; i++) {
    if (transactionsSum[transactionsSum.length - 1].x.isSame(transactions[i].x)) {
      transactionsSum[transactionsSum.length - 1].y += transactions[i].y
    } else {
      transactionsSum.push({x: transactions[i].x, y: transactions[i].y + transactionsSum[transactionsSum.length - 1].y})
    }
  }

  // 0000398: SRP-MIC Online Project
  // For Group 1, find the earliest Mk, and limit the other transactions to those after that.
  if (this.$store.state.userData.clientData.GroupId === 1) {
    let earliestMk = Math.min.apply(Math, this.$store.state.userData.market.map(function (transaction) { return (moment(transaction.TransDate, 'YYYY-MM-DD')) }))
    transactionsSum = transactionsSum
       .filter((transaction) => transaction.x.isAfter(earliestMk))
  }

  this.$store.state.userData.transactionsSum = transactionsSum

  // Create cumulative sum over time of market transactions
  let market = this.$store.state.userData.market
  .map(function (transaction) {
    return {x: moment(transaction.TransDate, 'YYYY-MM-DD'), y: parseFloat(transaction.TransAmount)}
  })
  .sort(function (left, right) {
    return left.x.diff(right.x)
  })

  let marketSum = market.length > 0 ? [{x: market[0].x, y: market[0].y}] : []
  for (let i = 1; i < market.length; i++) {
    // Handle multiple MK's for same date (present when viewing a
    // Deferered Adult Per Capita individual. Add the amount to the previous
    // plot point rather than adding a new plot point with the same timestamp.
    // nb: this assumes that the array is sorted by timestamp (which it is).
    if (market[i].x.isSame(marketSum[marketSum.length - 1].x)) {
      marketSum[marketSum.length - 1].y = marketSum[marketSum.length - 1].y + market[i].y
    } else {
      marketSum.push({x: market[i].x, y: market[i].y + marketSum[marketSum.length - 1].y})
    }
  }

  this.$store.state.userData.marketSum = marketSum

  this.$router.push('/dashboard/overview')
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Dashboard/ViewClient.js